import { getLocalStorage, isAuthenticated, isOrgAccess } from "../utils/helpers";
import { Navigate, Outlet, useLocation } from "react-router-dom";

const ProtectRoutes = () => {
  const location = useLocation();
  const userRole = getLocalStorage("userRole");
  const layoutView = getLocalStorage("layoutView") || (userRole ? userRole?.toLowerCase() : null);

  if (!isAuthenticated()) {
    return <Navigate to="/tenant/login" replace />;
  }

  if (isOrgAccess() && location.pathname === "/") return <Navigate to="/org/dashboard" replace />;

  if ((location.pathname === "/" || !location.pathname.includes("/tenant/users/")) && layoutView === "enduser" ) return  <Navigate to="/tenant/users/dashboard" replace />;

  if (location.pathname.includes("/tenant/users/") && layoutView === "admin" ) return  <Navigate to="/" replace />;
  
  return <Outlet />;
};

export default ProtectRoutes;